import { render, staticRenderFns } from "./PickingSupplyForProductionSuggestionInput.vue?vue&type=template&id=2b2d77cd&scoped=true&"
import script from "./PickingSupplyForProductionSuggestionInput.vue?vue&type=script&lang=js&"
export * from "./PickingSupplyForProductionSuggestionInput.vue?vue&type=script&lang=js&"
import style0 from "./PickingSupplyForProductionSuggestionInput.vue?vue&type=style&index=0&id=2b2d77cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d77cd",
  null
  
)

export default component.exports